/**
 * Register event handler to log important events to an external service
 * Events dispatched using code like: window.dispatchEvent(new CustomEvent('log:warning', {detail}));
 */
export function registerEventLogger() {
    window.addEventListener('log:error', handleLog);
    window.addEventListener('log:warning', handleLog);
    window.addEventListener('log:info', handleLog);
}

/**
 * @param {CustomEvent} event
 */
function handleLog(event) {
    const severity = event.type.split(':')[1];

    // @ts-ignore — bugsnag.js loads as an async module for page-load performance,
    // so window.bugsnagClient may not yet exist when early events fire.
    // A buffering approach was tried and reverted for being too complex (9d57e41).
    // If unreported errors become a problem, revisit that commit.
    const bugsnag = window.bugsnagClient;
    if (!bugsnag) {
        // eslint-disable-next-line no-console
        console[severity === 'warning' ? 'warn' : severity](event.detail);
        return;
    }

    /** @see https://docs.bugsnag.com/platforms/javascript/reporting-handled-errors/ */
    let notification = event.detail;
    if (!notification) {
        // eslint-disable-next-line no-console
        console.error('Event detail must be specified for logging');
        return;
    }

    bugsnag.notify(notification, (event) => {
        event.severity = severity;

        const metadata = notification.metadata;
        if (typeof metadata === 'object') {
            Object.keys(metadata).forEach((key) => {
                event.addMetadata(key, metadata[key]);
            });
        }
    });
}
